<template>
  <!--
  D: video popup
  - 이중팝업으로 뜨는 형태이기에 DOM위치를 앞전 팝업보다 뒤에 위치시켜주세요
  - 이중팝업으로 뜨는 대상은 data-popup에 has-multi-popup 값을 넣어주세요
-->
  <AbstractPop>
    <template v-slot>
      <div class="dialog type-video">
        <header class="dialog-header">
          <h2 class="sr-only">영상 팝업</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <div class="m-video-wrap">
              <h3 class="subject">
                {{ props.link.titleNm }}
              </h3>
              <!-- D: Video data -->
              <div class="video">
                <!-- D: video sample -->
                <template v-if="props.link.linkUrlSeCd === 'U'">
                  <iframe
                    :src="youtubeUrl"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </template>
                <template v-else-if="props.link.linkUrlSeCd === 'V'">
                  <iframe
                    :src="vimeoUrl"
                    width="640"
                    height="360"
                    frameborder="0"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowfullscreen
                  ></iframe>
                </template>
              </div>
              <!-- // D: Video data -->
            </div>
          </div>
        </div>
      </div>
      <!-- D: 이중팝업으로 뜨는 대상은 dimmed는 숨김처리 해주세요(퍼블은 css로 숨김처리 함) -->
      <div v-if="!props.isDoubleLayer" class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup name="videoLinkPop">
import { onMounted, defineEmits, defineProps, computed } from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";

const emits = defineEmits(["close"]);

const props = defineProps({
  /* 이중 팝업 여부. 다른 팝업에 의해서 표시되는 파업을 이중 팝업이라고 합니다. */
  isDoubleLayer: {
    type: Boolean,
    default: false,
  },
  link: {
    type: Object,
    required: true,
  },
});

onMounted(() => {});

const youtubeUrl = computed(() => {
  const regx = /youtu\.be\/(\w+)/;

  const match = props.link.linkUrl.match(regx);
  const videoId = match[1];

  return `https://www.youtube.com/embed/${videoId}?si=X9pSLalf4hvc_Dxq`;
});

const vimeoUrl = computed(() => {
  const regx = /vimeo\.com\/(\d+)/;

  const match = props.link.linkUrl.match(regx);
  const videoId = match[1];

  return `https://player.vimeo.com/video/${videoId}`;
});
</script>
